import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ProfileSettingTypeExtraInfo } from '@diritto/common/account/constants/profile-setting.constant';
import { MutateFn } from '@diritto/common/base/mutateFunction';
import { ProfileApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';
import { accountsQueryKey } from 'queries/account/queryKey';

export const useAddProfileSettingMutation = (callback?: MutateFn) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (extraDataInfo: ProfileSettingTypeExtraInfo[keyof ProfileSettingTypeExtraInfo]) =>
      ProfileApi.addProfileSetting({
        type: extraDataInfo.type,
        extraDataInfo,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: relayQueryKey.relayContent });
      queryClient.invalidateQueries({ queryKey: accountsQueryKey.user });
    },
    ...callback,
  });
};
